<!--
 * @Descripttion: 漏斗图
 * @Author: zenghua.wang
 * @Date: 2021-09-06 14:35:34
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-14 16:26:46
-->
<template>
  <div
    ref="container"
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <div
      :ref="id"
      :style="styleChart"
    ></div>
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import echart from '@/dragComponents/mixins/echart'
import {
  isEmpty,
  deepClone,
  isHasProp,
  setTooltipFormatter
} from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-echart-funnel',
  mixins: [bem, echart],
  directives: { customLoading },
  data() {
    return {
      component: component
    }
  },
  methods: {
    setOption() {
      const optionData = deepClone(this.optionData)
      let option = {
        title: isHasProp(
          this.option.titleShow,
          {
            text: this.option.titleText,
            subtext: this.option.titleSubtext,
            textStyle: {
              color: this.option.titleTextColor,
              fontSize: this.option.titleTextFontSize * (window?.scale || 1)
            },
            left: this.option.titleLeft || 'auto',
            top: this.option.titleTop || 'auto',
            subtextStyle: {
              color: this.option.titleSubtextColor,
              fontSize: this.option.titleSubtextFontSize * (window?.scale || 1)
            }
          },
          {}
        ),
        tooltip: isHasProp(
          !isEmpty(this.option.tipFormatter),
          {
            formatter: (params) => {
              return setTooltipFormatter(
                this.option.tipFormatter,
                params,
                this.dataList
              )
            }
          },
          {
            show: this.option.tipShow,
            textStyle: {
              fontSize: this.option.tipFontSize,
              color: this.option.tipColor
            }
          }
        ),
        legend: {
          show: this.option.legendShow,
          top: !isEmpty(this.option.legendTop)
            ? this.option.legendTop + '%'
            : 10,
          left: this.option.legendLeft,
          orient: this.option.legendOrient || 'horizontal',
          textStyle: {
            fontSize: this.option.legendFontSize
          },
          data: (() => {
            return (optionData.categories || []).map((ele, index) => {
              return {
                name: ele,
                textStyle: {
                  color: this.option.legendColor
                }
              }
            })
          })()
        },
        series: (() => {
          const list = (optionData.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: this.option.type,
              animationDelay: function(idx) {
                return Math.random() * 200
              },
              label: {
                show: this.option.labelShow,
                formatter: this.option.labelLine
                  ? ({ name, value }) => {
                    return !isEmpty(this.option.unit)
                      ? `${name}: ${value}${this.option.unit}`
                      : `${name}: ${value}`
                  }
                  : ({ name }) => {
                    return name
                  },
                position: this.option.labelLine ? 'right' : 'inside',
                textStyle: {
                  fontSize: this.option.labelShowFontSize,
                  color: this.option.labelShowColor,
                  fontWeight: this.option.labelShowFontWeight
                }
              },
              labelLine: {
                show: this.option.labelLine,
                length: 20,
                lineStyle: {
                  width: 1,
                  type: 'solid'
                }
              },
              itemStyle: isHasProp(
                this.showColor(),
                {
                  color: (params) => this.getColor(params.dataIndex)
                },
                {
                  // borderColor: '#fff',
                  // borderWidth: 1,
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              ),
              data: (() => {
                let dlist = ele.data
                if (this.option.notCount) {
                  dlist = dlist.filter((ele) => {
                    if (ele.value && ele.value !== 0) {
                      return true
                    }
                  })
                }
                if (this.option.sort) {
                  dlist.sort(function(a, b) {
                    return a.value - b.value
                  })
                } else {
                  dlist.sort(function(a, b) {
                    return b.value - a.value
                  })
                }
                return dlist
              })()
            })
          })
          return list
        })()
      }

      // 颜色设置
      // if (this.option.defaultColor) {
      //   option.color && delete option.color
      // } else {
      //   option.color = this.option.color
      // }

      this.dragChart.resize()
      this.dragChart.setOption(option, true)
      this.isChart = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init(mock.echart.series, mock.echart.categories)
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/echart/index.scss';
</style>
